import { render, staticRenderFns } from "./npc.vue?vue&type=template&id=3b2153d5"
import script from "./npc.vue?vue&type=script&lang=js"
export * from "./npc.vue?vue&type=script&lang=js"
import style0 from "./npc.vue?vue&type=style&index=0&id=3b2153d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports